export default __webpack_public_path__ + "static/media/productPage2.c2d80155.jpg";